import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://dynwxmohhmfipguwzcgb.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR5bnd4bW9oaG1maXBndXd6Y2diIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI0NzYwMzcsImV4cCI6MjA4ODA1MjAzN30.q3JmpdmPpwcTSrD-ePQrgmGplmRuktFHDCQj4XVTtOE';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface Booking {
  id?: string;
  room_type: string;
  room_id?: string;
  guest_first_name: string;
  guest_last_name: string;
  guest_name?: string;
  guest_email: string;
  guest_phone: string;
  check_in: string;
  check_out: string;
  num_guests: number;
  special_requests?: string;
  status: 'pending' | 'confirmed' | 'cancelled';
  created_at?: string;
  updated_at?: string;
}

export interface RoomInventory {
  id: string;
  room_type: string;
  total_rooms: number;
  updated_at: string;
}
